import fetchTimesheets from '../Services/fetchTimesheets'
import { setTimesheets } from '../State/timesheets'
import { setFetching } from '../State/fetching'

var previousProjectId = null

export default function(props) {
  return function(dispatch) {
    // Check if additionalFilter.project_id has changed
    var currentProjectId = props && props.additionalFilter && props.additionalFilter.project_id
    
    if (previousProjectId && currentProjectId && previousProjectId !== currentProjectId) {
      // Clear the old timesheets data and show loading state
      dispatch(setTimesheets([]))
      dispatch(setFetching(true))
      
      // Fetch the new timesheets
      dispatch(fetchTimesheets())
    }
    
    // Update the previous project ID
    previousProjectId = currentProjectId
  }
}
